

// click video count js
document.addEventListener("DOMContentLoaded", function () {

  const videoCards = document.querySelectorAll(".video-count-api .videocardapi");

  videoCards.forEach(function (card) {
    let clicked = false;
    card.addEventListener("click", async function () {

      if (clicked) return; // prevent multiple clicks
      clicked = true;

      const websiteName = document.body.getAttribute("data-website");
      const titleName = this.getAttribute("data-producttitle");
      const titleUrl = this.getAttribute("data-producturl");
      const titleSku = this.getAttribute("data-productsku");

      console.log("Sending:", websiteName, titleName, titleUrl);

      // Prepare form data
      const formData = new FormData();
      formData.append("website", websiteName);
      formData.append("title", titleName);
      formData.append("url", titleUrl);
      formData.append("sku", titleSku);

      try {
        const response = await fetch("https://digital.agarolifestyle.com/luvlap_api/click_video_count.php", {
          method: "POST",
          body: formData
        });

        const result = await response.json();
         console.log("API Response:", result);

      } catch (error) {
        console.error("Error submitting form:", error);
      }


    });
  });





  // video plaing 6 sec
  const videoCardsPlaying = document.querySelectorAll(".video-count-api .videocardpopupapi video");

  videoCardsPlaying.forEach(function (video) {

    // Listen for time updates on each video
    video.addEventListener("timeupdate", async function () {
      if (video.currentTime >= 6 && !video.hasLogged) {

        const videoCardsPlayingWebsite = document.body.getAttribute("data-website");
        const parentCard = video.closest(".videocardapi");
        const videoCardsPlayingTitleName = parentCard ? parentCard.getAttribute("data-producttitle") : null;
        const videoCardsPlayingURL = parentCard ? parentCard.getAttribute("data-producturl") : null;
        const videoCardsPlayingSKU = parentCard ? parentCard.getAttribute("data-productsku") : null;

        // Prepare form data
        const formData = new FormData();
        formData.append("website", videoCardsPlayingWebsite);
        formData.append("title", videoCardsPlayingTitleName);
        formData.append("url", videoCardsPlayingURL);
        formData.append("sku", videoCardsPlayingSKU);

        try {
          const response = await fetch("https://digital.agarolifestyle.com/luvlap_api/playing-video-count.php", {
            method: "POST",
            body: formData
          });

          const result = await response.json();
          //  console.log("API Response:", result);

        } catch (error) {
          console.error("Error submitting form:", error);
        }
      

        // console.log("Website:", videoCardsPlayingWebsite);
        // console.log("Title:", videoCardsPlayingTitleName);
        // console.log("Video has played for 6 seconds:", video);
        video.hasLogged = true; // Prevents multiple logs
      }
    });
    
  });




// end
});
